import './RemoteAccessStatus.css';

import React, { type FC, useEffect, useRef, useState } from 'react';
import { Toggle } from '@src/components';
import { CloudOff, CloudOn } from '@src/assets';
import { useRemoteAccess, useWifiNetworks } from '@src/contexts';
import { useOutsideClickAlerter } from '@src/hooks';

export const RemoteAccessStatus: FC = () => {
  const [showRemoteAccessControls, setShowRemoteAccessControls] = useState(false);
  const remoteAccessModalRef = useRef(null);
  const { remoteAccessEnabled, requestRemoteAccess } = useRemoteAccess();
  useOutsideClickAlerter(remoteAccessModalRef, () => { setShowRemoteAccessControls(false); });
  const { requestNetworkPolling, connectedWifiNetwork } = useWifiNetworks();

  useEffect(() => {
    if (remoteAccessEnabled) {
      setShowRemoteAccessControls(false);
    }
  }, [remoteAccessEnabled]);

  useEffect(() => {
    return requestNetworkPolling();
  }, []);

  return (
    <div className={'remote_access_status_container remote_access_status_pointer'}>
      {remoteAccessEnabled ? <CloudOn/> : <CloudOff onClick={() => { setShowRemoteAccessControls(true); }} /> }
      {showRemoteAccessControls ? <RemoteAccessControls containerRef={remoteAccessModalRef} setRemoteAccess={requestRemoteAccess} remoteAccessEnabled={remoteAccessEnabled} isWifiConnected={connectedWifiNetwork !== undefined} /> : null}
    </div>
  );
};

interface RemoteAccessControlProps {
  setRemoteAccess: (boolean) => void
  remoteAccessEnabled: boolean
  containerRef: React.RefObject<HTMLDivElement>
  isWifiConnected: boolean
}

const RemoteAccessControls: FC<RemoteAccessControlProps> = ({ setRemoteAccess, remoteAccessEnabled, containerRef, isWifiConnected }) => {
  return (
    <div className="remote_access_modal_container" ref={containerRef}>
      <div className={`remote_access_modal_controls ${!isWifiConnected ? 'disabled' : ''}`}>
        <div className="remote_access_modal_title">Enable Remote Access</div>
        <Toggle onClick={() => { setRemoteAccess(!remoteAccessEnabled); }} disabled={!isWifiConnected} checked={remoteAccessEnabled} onText="ON" offText="OFF" />
      </div>
      {!isWifiConnected ? <WarningPill /> : null}
    </div>
  );
};

const WarningPill: FC = () => {
  return (
    <div className="remote_access_modal_warning">
      <i className="fal fa-2x fa-exclamation-triangle" />
      <span>Remote deployment cannot be enabled if WiFi is not connected.</span>
    </div>
  );
};
